webpackJsonp([235],{

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditTaskTable_vue__ = __webpack_require__(2538);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b66278_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditTaskTable_vue__ = __webpack_require__(3278);
function injectStyle (ssrContext) {
  __webpack_require__(3276)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31b66278"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditTaskTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b66278_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditTaskTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InternOnlyAccessRedirectCard',
  methods: {
    redirectToOrderTable: function redirectToOrderTable() {
      this.$router.push({
        path: '/order/table'
      });
    }
  }
});

/***/ }),

/***/ 1679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternOnlyAccessRedirectCard_vue__ = __webpack_require__(1586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_024dab3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternOnlyAccessRedirectCard_vue__ = __webpack_require__(1742);
function injectStyle (ssrContext) {
  __webpack_require__(1740)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-024dab3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternOnlyAccessRedirectCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_024dab3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternOnlyAccessRedirectCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1740:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f4d361a0", content, true, {});

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".intern-only-message[data-v-024dab3a]{margin-top:18px}.intern-only-card[data-v-024dab3a]{border-radius:12px;background:#f6f8ff;border:1px solid #e1e8ff}.intern-only-header[data-v-024dab3a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;font-weight:600;color:#303133;font-size:14px}.intern-only-content[data-v-024dab3a]{padding-top:2px}.intern-only-title[data-v-024dab3a]{font-size:16px;font-weight:700;color:#303133;margin-bottom:6px}.intern-only-desc[data-v-024dab3a]{font-size:14px;color:#606266;line-height:1.6;margin-bottom:16px}.intern-only-btn[data-v-024dab3a]{font-weight:600}", "", {"version":3,"sources":["/workspace/src/components/InternOnlyAccessRedirectCard.vue"],"names":[],"mappings":"AACA,sCAAsC,eAAe,CACpD,AACD,mCAAmC,mBAAmB,mBAAmB,wBAAwB,CAChG,AACD,qCAAqC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,gBAAgB,cAAc,cAAc,CAChN,AACD,sCAAsC,eAAe,CACpD,AACD,oCAAoC,eAAe,gBAAgB,cAAc,iBAAiB,CACjG,AACD,mCAAmC,eAAe,cAAc,gBAAgB,kBAAkB,CACjG,AACD,kCAAkC,eAAe,CAChD","file":"InternOnlyAccessRedirectCard.vue","sourcesContent":["\n.intern-only-message[data-v-024dab3a]{margin-top:18px\n}\n.intern-only-card[data-v-024dab3a]{border-radius:12px;background:#f6f8ff;border:1px solid #e1e8ff\n}\n.intern-only-header[data-v-024dab3a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;font-weight:600;color:#303133;font-size:14px\n}\n.intern-only-content[data-v-024dab3a]{padding-top:2px\n}\n.intern-only-title[data-v-024dab3a]{font-size:16px;font-weight:700;color:#303133;margin-bottom:6px\n}\n.intern-only-desc[data-v-024dab3a]{font-size:14px;color:#606266;line-height:1.6;margin-bottom:16px\n}\n.intern-only-btn[data-v-024dab3a]{font-weight:600\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intern-only-message"},[_c('el-card',{staticClass:"intern-only-card",attrs:{"shadow":"hover","body-style":{ padding: '18px 18px 20px' }}},[_c('div',{staticClass:"intern-only-header",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v(" "),_c('span',[_vm._v("访问限制")])]),_vm._v(" "),_c('div',{staticClass:"intern-only-content"},[_c('div',{staticClass:"intern-only-title"},[_vm._v("此页面仅实习生可操作")]),_vm._v(" "),_c('div',{staticClass:"intern-only-desc"},[_vm._v("请直接到“任务管理-工单管理”进行审单")]),_vm._v(" "),_c('el-button',{staticClass:"intern-only-btn",attrs:{"type":"primary"},on:{"click":_vm.redirectToOrderTable}},[_vm._v("跳转到工单列表")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InternOnlyAccessRedirectCard_vue__ = __webpack_require__(1679);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_table_v3__["a" /* default */]],
  components: {
    InternOnlyAccessRedirectCard: __WEBPACK_IMPORTED_MODULE_6__components_InternOnlyAccessRedirectCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      todayAuditedTotal: 0,
      search: {
        orderid: this.$route.query.order_id || null,
        status: null,
        is_wrong: null
      },
      searchFieldType: {
        orderid: Number,
        status: Number,
        is_wrong: Number
      },
      statusOptions: [{ label: '待审核', value: 1 }, { label: '已审核', value: 2 }, { label: '超时释放', value: 3 }, { label: '失效', value: 4 }],
      lockOptions: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
      isWrongOptions: [{ label: '否', value: 1 }, { label: '是', value: 2 }],
      wrongSourceOption: [{ label: '工单复核', value: 1 }, { label: 'Keyin反馈', value: 2 }, { label: '零工申诉', value: 3 }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_vuex__["default"].mapState({
    user: function user(state) {
      return state.login.user;
    },
    orderOptions: function orderOptions(state) {
      return state.order && state.order.options ? state.order.options : { allType: [] };
    }
  }), {
    isIntern: function isIntern() {
      return parseInt(this.user && this.user.usertype) === 4;
    }
  }),
  created: function created() {
    if (!this.isIntern) return;
    this.loadTodayAuditedTotal();
  },

  methods: {
    getTableData: function getTableData(params) {
      if (!this.isIntern) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
          data: {
            data: [],
            current_page: params.current_page || 1,
            per_page: params.per_page || 50,
            total: 0
          }
        });
      }
      return request.page('queryAuditTask', params);
    },
    onRefresh: function onRefresh() {
      var _this = this;

      return this.getTableData(this.lastSearchParams).then(function (res) {
        _this.setTableData(res);
        _this.loadTodayAuditedTotal();
        return res;
      });
    },
    loadTodayAuditedTotal: function loadTodayAuditedTotal() {
      var _this2 = this;

      var start = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD 00:00:00');
      var end = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD 23:59:59');
      return request.page('queryAuditTask', {
        status: 2,
        reviewedtime: [start, end],
        current_page: 1,
        per_page: 1
      }).then(function (_ref) {
        var data = _ref.data;

        _this2.todayAuditedTotal = data.total || 0;
      }).catch(function () {
        // 统计失败时不影响列表
      });
    },
    getStatusLabel: function getStatusLabel(status) {
      var it = this.statusOptions.find(function (x) {
        return parseInt(x.value) === parseInt(status);
      });
      return it ? it.label : status === null || status === undefined ? '' : String(status);
    },
    getLockLabel: function getLockLabel(isInAudit) {
      var it = this.lockOptions.find(function (x) {
        return parseInt(x.value) === parseInt(isInAudit);
      });
      return it ? it.label : isInAudit === null || isInAudit === undefined ? '' : String(isInAudit);
    },
    getIsWrongLabel: function getIsWrongLabel(isWrong) {
      var it = this.isWrongOptions.find(function (x) {
        return parseInt(x.value) === parseInt(isWrong);
      });
      return it ? it.label : isWrong === null || isWrong === undefined ? '' : String(isWrong);
    },
    getWrongSourceLabel: function getWrongSourceLabel(wrongSource) {
      var it = this.wrongSourceOption.find(function (x) {
        return parseInt(x.value) === parseInt(wrongSource);
      });
      return it ? it.label : wrongSource === null || wrongSource === undefined ? '' : String(wrongSource);
    },
    getAuditResultLabel: function getAuditResultLabel(row) {
      var status = parseInt(row && row.status);
      var isPassed = parseInt(row && row.is_passed);
      // 1、空字符串（is_passed=0 and 状态=未审核）
      if (isPassed === 0 && status === 1) return '';
      // 2、审核通过(is_passed = 1)
      if (isPassed === 1) return '审核通过';
      // 3、审核驳回(is_passed=0 and 状态=已审核)
      if (isPassed === 0 && status === 2) return '审核驳回';
      return '';
    },
    getTaskTypeLabel: function getTaskTypeLabel(type) {
      var allType = this.orderOptions && this.orderOptions.allType ? this.orderOptions.allType : [];
      var it = allType.find(function (x) {
        return parseInt(x.value) === parseInt(type);
      });
      return it ? it.label : type === null || type === undefined ? '' : String(type);
    },
    formatSalary: function formatSalary(salary) {
      if (salary === null || salary === undefined || salary === '') return '';
      var n = Number(salary);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n)) return String(salary);
      return n.toFixed(2);
    },

    /** 审核任务状态：3 = 超时释放（与 order-audit-api AuditTask::STATUS_AUTO_RELEASE 一致） */
    isAuditTaskTimeoutReleased: function isAuditTaskTimeoutReleased(row) {
      return parseInt(row && row.status, 10) === 3;
    },
    onView: function onView(row) {
      this.$router.push({
        path: '/order/review/' + row.orderid
      });
    },
    onUnlock: function onUnlock(row) {
      var _this3 = this;

      this.$confirm('确认解除该工单的锁单状态？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 同步解锁：先解锁主平台，再清除本地锁定状态
        return request.alert('unlockAuditTask', { id: row.id }).then(function () {
          return _this3.onRefresh();
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ 3276:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3277);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("770d73ce", content, true, {});

/***/ }),

/***/ 3277:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".today-total-pill[data-v-31b66278]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 18px;border-radius:999px;background:-webkit-gradient(linear,left top,right top,from(#eaf4ff),to(#dff0ff));background:linear-gradient(90deg,#eaf4ff,#dff0ff);border:1px solid #d3e8ff;color:#3a7bff;font-size:16px;line-height:20px;font-weight:600;-webkit-box-shadow:0 6px 18px rgba(58,123,255,.12);box-shadow:0 6px 18px rgba(58,123,255,.12);letter-spacing:.5px}.today-total-pill__num[data-v-31b66278]{margin-left:6px;font-weight:700}", "", {"version":3,"sources":["/workspace/src/views/audit-task/pages/AuditTaskTable.vue"],"names":[],"mappings":"AACA,mCACE,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,oBAAqB,AACrB,iFAAsF,AACtF,kDAA6D,AAC7D,yBAA0B,AAC1B,cAAe,AACf,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,mDAAwD,AAChD,2CAAgD,AACxD,mBAAsB,CACvB,AACD,wCACE,gBAAiB,AACjB,eAAiB,CAClB","file":"AuditTaskTable.vue","sourcesContent":["\n.today-total-pill[data-v-31b66278] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 10px 18px;\n  border-radius: 999px;\n  background: -webkit-gradient(linear, left top, right top, from(#eaf4ff), to(#dff0ff));\n  background: linear-gradient(90deg, #eaf4ff 0%, #dff0ff 100%);\n  border: 1px solid #d3e8ff;\n  color: #3a7bff;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  -webkit-box-shadow: 0 6px 18px rgba(58, 123, 255, 0.12);\n          box-shadow: 0 6px 18px rgba(58, 123, 255, 0.12);\n  letter-spacing: 0.5px;\n}\n.today-total-pill__num[data-v-31b66278] {\n  margin-left: 6px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[(!_vm.isIntern)?_c('intern-only-access-redirect-card'):[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"工单ID","prop":"orderid"}},[_c('el-input',{attrs:{"placeholder":"请输入工单ID","clearable":""},model:{value:(_vm.search.orderid),callback:function ($$v) {_vm.$set(_vm.search, "orderid", $$v)},expression:"search.orderid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"错审工单","prop":"is_wrong"}},[_c('el-select',{attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.is_wrong),callback:function ($$v) {_vm.$set(_vm.search, "is_wrong", $$v)},expression:"search.is_wrong"}},_vm._l((_vm.isWrongOptions),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":it.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"审核状态","prop":"status"}},[_c('el-select',{attrs:{"placeholder":"请选择","clearable":"","filterable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.statusOptions),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":it.value}})}),1)],1),_vm._v(" "),(false)?_c('el-form-item',{attrs:{"label":"锁单状态","prop":"is_stashed"}},[_c('el-select',{attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.is_stashed),callback:function ($$v) {_vm.$set(_vm.search, "is_stashed", $$v)},expression:"search.is_stashed"}},_vm._l((_vm.lockOptions),function(it){return _c('el-option',{key:it.value,attrs:{"label":it.label,"value":it.value}})}),1)],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n            ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"orderid","label":"工单ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              ORD"+_vm._s(scope.row.orderid)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"任务标题","min-width":"160px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"任务类型"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getTaskTypeLabel(scope.row.type))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userid","label":"完成人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"赏金"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.formatSalary(scope.row.salary))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"审核结果"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getAuditResultLabel(scope.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"publishtime","label":"任务时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"城市"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.provincename)+_vm._s(scope.row.cityname)+_vm._s(scope.row.areaname)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"门店名称"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_stashed","label":"锁单状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getLockLabel(scope.row.is_stashed))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_wrong","label":"错单状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getIsWrongLabel(scope.row.is_wrong))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wrong_source","label":"错审来源"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getWrongSourceLabel(scope.row.wrong_source))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"审核状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getStatusLabel(scope.row.status))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reviewedtime","label":"审核时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"150px","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isAuditTaskTimeoutReleased(scope.row))?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.onView(scope.row)}}},[_vm._v("查看")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini","disabled":parseInt(scope.row.is_stashed) !== 1},on:{"click":function($event){return _vm.onUnlock(scope.row)}}},[_vm._v("解锁")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-task-table.c27845072859cb8096d2.js